import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/YoutubeCmsConfirmedRevenueLatestMonth.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useYoutubeCmsConfirmedRevenueLatestMonthQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useYoutubeCmsConfirmedRevenueLatestMonthLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & {
  getYoutubeCmsConfirmedRevenueLatestMonthQuery: LazyQueryExecFunction<Query, OperationVariables>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getYoutubeCmsConfirmedRevenueLatestMonth
  const [getYoutubeCmsConfirmedRevenueLatestMonthQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getYoutubeCmsConfirmedRevenueLatestMonthQuery, ...result };
};

export const useYoutubeCmsConfirmedRevenueLatestMonthPromiseQuery = () => {
  const client = useApolloClient();

  const getYoutubeCmsConfirmedRevenueLatestMonth = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getYoutubeCmsConfirmedRevenueLatestMonth };
};
